import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { ADMIN_EMAILS } from "../lib/adminEmails";

export function useIsAppAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function check(email: string | undefined | null, userId: string | undefined) {
      if (ADMIN_EMAILS.includes(email ?? "")) {
        if (!cancelled) {
          setIsAdmin(true);
          setLoading(false);
        }
        return;
      }

      if (!userId) {
        if (!cancelled) {
          setIsAdmin(false);
          setLoading(false);
        }
        return;
      }

      const { data } = await supabase
        .from("app_admins")
        .select("user_id")
        .eq("user_id", userId)
        .maybeSingle();

      if (!cancelled) {
        setIsAdmin(!!data?.user_id);
        setLoading(false);
      }
    }

    supabase.auth.getUser().then(({ data: { user } }) => {
      check(user?.email, user?.id);
    });

    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      const user = session?.user;
      setLoading(true);
      check(user?.email, user?.id);
    });

    return () => {
      cancelled = true;
      listener.subscription.unsubscribe();
    };
  }, []);

  return { isAdmin, loading };
}
